import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { SPACING_SIZE_ICON_LARGE } from '@saffron/styles';
import { t as testChild, E as ErrorEnum } from './index2.js';
import { d as defineCustomElement$1 } from './saf-svg2.js';

const safIconCss = ".saf-icon{align-items:center;display:inline-flex;justify-content:center}";

const SafIcon = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.semantic = undefined;
    this.animated = undefined;
    this.iconData = '';
    this.size = SPACING_SIZE_ICON_LARGE;
    this.color = undefined;
  }
  buildSemantic() {
    if (this.svgElem && this.hostElem.shadowRoot) {
      this.hostElem.shadowRoot.append(this.svgElem);
    }
    this.hostElem.style.height = this.size;
    this.hostElem.style.width = this.size;
    // Fix for safari rendering bug
    this.svgElem.style.height = this.size;
    this.svgElem.style.width = this.size;
    if (this.color)
      this.hostElem.style.color = this.color;
  }
  buildShorthand() {
    return h("saf-svg", { svgData: this.iconData, size: this.size, color: this.color, animated: this.animated });
  }
  componentWillLoad() {
    if (this.semantic) {
      this.svgElem = this.hostElem.querySelector('svg');
      testChild(this.svgElem, ErrorEnum.safIcon, this.buildSemantic.bind(this));
    }
  }
  render() {
    return h(Host, { class: "saf-icon" }, !this.semantic && this.buildShorthand());
  }
  get hostElem() { return this; }
  static get style() { return safIconCss; }
}, [0, "saf-icon", {
    "semantic": [4],
    "animated": [4],
    "iconData": [1, "icon-data"],
    "size": [1],
    "color": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["saf-icon", "saf-svg"];
  components.forEach(tagName => { switch (tagName) {
    case "saf-icon":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, SafIcon);
      }
      break;
    case "saf-svg":
      if (!customElements.get(tagName)) {
        defineCustomElement$1();
      }
      break;
  } });
}

export { SafIcon as S, defineCustomElement as d };

